import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "./resources/en";
import { fr } from "./resources/fr";
import { it } from "./resources/it";

export const I18N_STORAGE_KEY = "blackflag-language";
export const supportedLanguages = ["it", "en", "fr"] as const;

export type AppLanguage = (typeof supportedLanguages)[number];

const resources = {
  it,
  en,
  fr,
} as const;

const getInitialLanguage = (): AppLanguage => {
  if (typeof window === "undefined") {
    return "it";
  }

  const storedLanguage = window.localStorage.getItem(I18N_STORAGE_KEY);

  if (storedLanguage && supportedLanguages.includes(storedLanguage as AppLanguage)) {
    return storedLanguage as AppLanguage;
  }

  const browserLanguage = window.navigator.language.slice(0, 2).toLowerCase();

  return supportedLanguages.includes(browserLanguage as AppLanguage)
    ? (browserLanguage as AppLanguage)
    : "it";
};

void i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLanguage(),
  fallbackLng: "en",
  defaultNS: "common",
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", (language) => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem(I18N_STORAGE_KEY, language);
});

export default i18n;